import { useDatasourceId, useQueryId, useSeriesId } from '@/hooks';
import { useGetQueryColumnsQuery } from '@/features/query-builder/queriesApiSlice';
import { useGetSavedQueryColumnsQuery } from '@/features/query-builder/savedQueriesApiSlice';

export const useLoadColumns = (
  skip = false,
  additionalParams: {
    layerInEditModeId?: number;
    stepInEditModeIndex?: number;
    includeHidden?: boolean;
  } = {},
) => {
  const datasourceId = useDatasourceId();
  const queryId = useQueryId();
  const seriesId = useSeriesId();

  const commonParams = {
    datasourceId,
    ...additionalParams,
  };

  const queryResult = useGetQueryColumnsQuery(
    { queryId, ...commonParams },
    {
      skip: !queryId || skip,
    },
  );

  const savedQueryResult = useGetSavedQueryColumnsQuery(
    { seriesId, ...commonParams },
    {
      skip: !seriesId || skip,
    },
  );

  if (seriesId) return savedQueryResult;

  return queryResult;
};
